export default {
  infrastructureEdit: null,
  infrastructureStatuses: null,
  infrastructureTree: null,
  infrastructureMapParams: null,
  infrastructureMapObject: null,
  infrastructureMapData: {},
  infrastructureTechnology: null,
  infrastructureTechnologies: [],
  infrastructureTechnologyTree: [],
  infrastructureTechnologyEdit: null,
  infrastructureTechnologyCreated: null,
  infrastructureTechnologyCurrentParams: null,
}



// WEBPACK FOOTER //
// ./src/store/infrastructures/defaults.js